import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShipmentById, getShipmentPaymentBySN } from '../../store/reducers/Shipment/actions';
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, RootStateType } from '../../store';
import PackagingDetails from './PackagingDetails';
import Title from '../../components/Title';
import ShipmentHistoryActions from './ShipmentHistoryActions';
import ShipperConsigneeDetails from './ShipperConsigneeDetails';
import { Alert, Grid } from '@mui/material';
import ShipmentCharges from './ShipmentCharges';
import ShipmentDetails from './ShipmentDetails';
import TrackingDetails from './TrackingDetails';
import { resetShipmentById } from '@Reducers/Shipment';
import { getShipmentSettings } from '@Reducers/OrganizationSetup';
import Loader from '@Components/Loader';
import CancelAndTrackShipment from '@Components/CancelAndTrackShipment';
import { useWebsocket } from '@Hook/useWebsocket';

export function ViewSingleShipment() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id: shipmentId } = useParams();
  const { loading, shipmentCancelled } = useSelector((state: RootStateType) => state.shipmentHistory);
  const { shipmentById } = useSelector((state: RootStateType) => state.shipment);
  const { profile } = useSelector((state: RootStateType) => state.loginUser);
  const shipmentpayment = useSelector((state: RootStateType) => state.adminShipment.shipmentpayment);
  const { availableLimit } = useSelector((state: RootStateType) => state.Credit);

  useEffect(() => {
    if (shipmentId) {
      dispatch(getShipmentSettings());
      dispatch(getShipmentById(shipmentId));
      dispatch(getShipmentPaymentBySN(shipmentId));
    }
    return () => {
      dispatch(resetShipmentById());
    };
  }, []);

  useEffect(() => {
    if (shipmentCancelled) {
      navigate('/shipment/history');
    }
  }, [shipmentCancelled]);

  useWebsocket({
    query: {
      channel: 'shipment-update-' + shipmentId,
    },
  });

  return (
    <Loader loading={loading} overly>
      <>
        <Title title="Shipment History" removeBorder />
        <ShipmentHistoryActions />
        <Grid sx={{ marginY: '20px' }} container justifyContent="space-between" alignItems="center">
          {/* Left Side Alert */}
          <Grid item>
            {profile?._accountId.isPrepaid
              ? Number(shipmentpayment?.payableAmount) > 0 &&
                shipmentById?.invoiceStatus === 'unpaid' && (
                  <Alert
                    variant="outlined"
                    severity="error"
                    className="w-fit border-grey sb-text-error sm-text"
                    sx={{ height: '44px', py: '2px' }}
                  >
                    This shipment has an outstanding payment. Please complete the payment to continue processing.
                  </Alert>
                )
              : availableLimit < 0 && (
                  <Alert
                    variant="outlined"
                    severity="error"
                    className="w-fit border-grey sb-text-error sm-text"
                    sx={{ height: '44px', py: '2px' }}
                  >
                    Your credit limit has been exceeded. Please clear the outstanding dues to proceed with this
                    shipment.
                  </Alert>
                )}
          </Grid>

          {/* Right Side Buttons */}
          <Grid item>
            {shipmentById?.status && (
              <CancelAndTrackShipment
                shipmentStatus={shipmentById.status}
                accountId={shipmentById?._userId._id}
                showAlert={
                  profile?._accountId.isPrepaid
                    ? Number(shipmentpayment?.payableAmount) > 0 && shipmentById?.invoiceStatus === 'unpaid'
                    : availableLimit < 0
                }
              />
            )}
          </Grid>
        </Grid>

        <TrackingDetails />
        <PackagingDetails />
        <Grid container columnSpacing={{ lg: 5, md: 7, sm: 0 }} rowSpacing={{ lg: 0, md: 0, sm: 7 }}>
          <Grid item lg={8} md={7} sm={12} xs={12}>
            <ShipperConsigneeDetails />
          </Grid>
          <Grid item lg={4} md={5} sm={12} xs={12}>
            <ShipmentCharges />
          </Grid>
        </Grid>
        <ShipmentDetails />
      </>
    </Loader>
  );
}

export default ViewSingleShipment;
